const useInvitacionStore = defineStore("invitacion", () => {
  // state
  const invitacion = ref({
    id: null,
    nombre: null,
    email: null,
    mensaje: "",
    estatus: 3, // default es enviada
    sub_titulo: null,
    invitador_id: null,
    invitador: null,
    configuracion_id: null,
    configuracion: {
      id: null,
      titulo: null,
      sub_titulo: null,
      tipo_biografia: null,
    },

    colaboraciones: [],
  });

  const invitaciones = ref([]);

  // getters

  const draft = computed(() => clone(invitacion.value));

  // mutations

  const setInvitacion = (payload) => {
    invitacion.value = payload;
  };

  const clear = () => {
    invitacion.value = {
      id: null,
      nombre: null,
      email: null,
      mensaje: "",
      estatus: 3, // default es enviada
      sub_titulo: null,
      invitador_id: null,
      invitador: null,
      configuracion_id: null,
      configuracion: {
        id: null,
        titulo: null,
        sub_titulo: null,
        tipo_biografia: null,
      },
      colaboraciones: [],
    };
  };

  const setInvitaciones = (payload) => (invitaciones.value = payload);

  // actions
  const fetch = (inv_id) => {
    return new Promise((resolve, reject) => {
      axios
        .get(`/api/invitacions/${inv_id}/fetch-data`)
        .then(({ data }) => {
          setInvitacion(data);
          resolve(data);
        })
        .catch((e) => reject(e));
    });
  };

  const fetchData = (params) => {
    return new Promise((resolve, reject) => {
      axios
        .post(`api/invitacions/fetch-data`, params)
        .then(({ data }) => {
          resolve(data);
        })
        .catch((e) => reject(e));
    });
  };

  const guardar = (datos) => {
    return new Promise((resolve, reject) => {
      if (datos.id) {
        axios
          .post(`/api/invitacions/${datos.id}`, datos)
          .then(({ data }) => resolve(data))
          .catch((e) => reject(e));
      } else {
        axios
          .post(`/api/invitacions`, datos)
          .then(({ data }) => resolve(data))
          .catch((e) => reject(e));
      }
    });
  };

  const eliminar = (inv_id) => {
    return new Promise((resolve, reject) => {
      axios
        .delete(`/api/invitacions/${inv_id}`)
        .then(({ data }) => resolve(data))
        .catch((e) => reject(e));
    });
  };

  const fetchInvitacionPorToken = (token) => {
    return new Promise((resolve, reject) => {
      axios
        .get(`/api/invitacions/tokens/${token}/fetch/fetch-data`)
        .then(({ data }) => {
          if (data.id) {
            setInvitacion(data);
          }
          resolve(data);
        })
        .catch((e) => reject(e));
    });
  };

  const actualizarInvitacion = (inv_id, datos) => {
    return new Promise((resolve, reject) => {
      axios
        .put(`/api/invitacions/${inv_id}/toggle-invitacion`, datos)
        .then(({ data }) => {
          if (data.result) {
            setInvitacion(data.invitacion);
          }
          resolve(data);
        })
        .catch((e) => reject(e));
    });
  };

  const getInvitaciones = (config_id) => {
    return new Promise((resolve, reject) => {
      axios
        .get(`/api/invitacions/configuracions/${config_id}/fetcth-all`)
        .then(({ data }) => {
          setInvitaciones(data);
          resolve(data);
        })
        .catch((e) => reject(e));
    });
  };

  return {
    invitacion,
    invitaciones,
    draft,
    setInvitacion,
    setInvitaciones,
    fetch,
    clear,
    fetchData,
    guardar,
    eliminar,
    fetchInvitacionPorToken,
    actualizarInvitacion,
    getInvitaciones,
  };
});

export default useInvitacionStore;
